import { motion, Variants } from "framer-motion";
import { isMobileOnly } from "react-device-detect";

const FeatureSection = ({ setActiveFeature, feature }) => {
  const cardVariants: Variants = {
    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 4,
      },
    },
  };

  const handleEnter = () => {
    setActiveFeature(feature);
  };
  return (
    <motion.div
      onViewportEnter={handleEnter}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: false, amount: 0.5, margin: `${isMobileOnly ? "-45%" : "0%"} 0% 0% 0%` }}
      className="feature-item"
    >
      <motion.div variants={cardVariants} className="content-container">
        <p className="sub-header">{feature.subtitle}</p>
        <h2>{feature.title}</h2>
        <p className="text">{feature.text}</p>
      </motion.div>
    </motion.div>
  );
};

export default FeatureSection;
